// extracted by mini-css-extract-plugin
export default {"container":"LoadingPlaceholder_container__D+4Cx","aria":"LoadingPlaceholder_aria__pwg9+"};